import { Col, Row } from "react-bootstrap";
import { BsTwitterX } from "react-icons/bs";
import { FaLinkedinIn } from "react-icons/fa";
import { FiPhone } from "react-icons/fi";
import { MdOutlineMailOutline } from "react-icons/md";
import { Link } from "react-router-dom";
import { footerContent } from "../../utils/globalVariables";

const FooterSecondary = () => {
  return (
    <footer className="msq-bg-dark-blue py-4">
      <div className="container">
        <Row>
          <Col md={9}>
            <div className="text-light">
              <h5 className="mb-3">Location</h5>
              <p>
                Akshar Blue Chip IT Park, 203, Turbhe MIDC, <br /> Turbhe, Navi
                Mumbai, Maharashtra 400705
              </p>
            </div>
          </Col>
          <Col md={3}>
            <div className="text-light">
              <h5 className="fw-semibold mb-3">Reach us at</h5>
              <p className="mb-2">
                <FiPhone /> <span>{footerContent.contact}</span>
              </p>
              <p>
                <MdOutlineMailOutline /> <span>{footerContent.email}</span>
              </p>
            </div>
          </Col>
        </Row>
        <hr className="text-light" />
        <div className="d-flex align-items-center">
          <div className="footer-icon-wrapper me-3">
            <Link
              to={"mailto:careers@intelegain.com"}
              className="d-flex align-items-center"
            >
              <MdOutlineMailOutline />
            </Link>
          </div>
          <div className="footer-icon-wrapper me-3">
            <Link
              to={"https://x.com/Intelegain"}
              target="_blank"
              className="d-flex align-items-center"
            >
              <BsTwitterX />
            </Link>
          </div>
          <div className="footer-icon-wrapper">
            <Link
              to={
                "https://in.linkedin.com/company/intelgain-technologies-pvt-ltd"
              }
              target="_blank"
              className="d-flex align-items-center"
            >
              <FaLinkedinIn />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSecondary;
